import { helpers } from './base'

export const Collapsible = helpers.defineMultiStyleConfig({
  baseStyle: helpers.definePartsStyle({}),
})
